import React, { useState } from 'react';
import { Mail, Check, Loader2 } from 'lucide-react';
export function WaitlistForm() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [companySize, setCompanySize] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    // Simulate API call
    setTimeout(() => {
      setStatus('success');
      setEmail('');
      setName('');
      setCompanySize('');
    }, 1500);
  };
  return <section id="waitlist" className="py-24 bg-slate-50" data-id="element-260">
      <div className="container mx-auto px-4 max-w-xl" data-id="element-261">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-slate-100" data-id="element-262">
          <div className="text-center mb-8" data-id="element-263">
            <h2 className="text-3xl font-bold text-slate-900 mb-3" data-id="element-264">
              Join the Beta Waitlist
            </h2>
            <p className="text-slate-600" data-id="element-265">
              Be the first to access the ATD Platform and get exclusive
              resources on engineering org design.
            </p>
          </div>

          {status === 'success' ? <div className="bg-green-50 border border-green-100 rounded-xl p-8 text-center animate-in fade-in zoom-in" data-id="element-266">
              <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-267">
                <Check className="h-8 w-8" data-id="element-268" />
              </div>
              <h3 className="text-2xl font-bold text-green-800 mb-2" data-id="element-269">
                You're on the list!
              </h3>
              <p className="text-green-700" data-id="element-270">
                Thanks for joining. We'll be in touch soon with your early
                access invite.
              </p>
              <button onClick={() => setStatus('idle')} className="mt-6 text-sm font-medium text-green-700 hover:text-green-800 underline" data-id="element-271">
                Register another email
              </button>
            </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-272">
              <div data-id="element-273">
                <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-274">
                  Full Name (Optional)
                </label>
                <input type="text" id="name" value={name} onChange={e => setName(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all" placeholder="Jane Doe" data-id="element-275" />
              </div>

              <div data-id="element-276">
                <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-277">
                  Work Email <span className="text-red-500" data-id="element-278">*</span>
                </label>
                <div className="relative" data-id="element-279">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" data-id="element-280" />
                  <input type="email" id="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full pl-10 pr-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all" placeholder="jane@company.com" data-id="element-281" />
                </div>
              </div>

              <div data-id="element-282">
                <label htmlFor="size" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-283">
                  Company Size (Optional)
                </label>
                <select id="size" value={companySize} onChange={e => setCompanySize(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all bg-white" data-id="element-284">
                  <option value="" data-id="element-285">Select size...</option>
                  <option value="1-50" data-id="element-286">1-50 employees</option>
                  <option value="50-200" data-id="element-287">50-200 employees</option>
                  <option value="200-500" data-id="element-288">200-500 employees</option>
                  <option value="500+" data-id="element-289">500+ employees</option>
                </select>
              </div>

              <button type="submit" disabled={status === 'loading'} className="w-full bg-indigo-600 text-white font-bold py-3 rounded-lg hover:bg-indigo-700 transition-colors shadow-md disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center" data-id="element-290">
                {status === 'loading' ? <>
                    <Loader2 className="mr-2 h-5 w-5 animate-spin" data-id="element-291" />
                    Joining...
                  </> : 'Join Waitlist'}
              </button>

              <p className="text-xs text-center text-slate-500 mt-4" data-id="element-292">
                We respect your privacy. No spam, ever. Unsubscribe at any time.
              </p>
            </form>}
        </div>
      </div>
    </section>;
}